import { render, staticRenderFns } from "./AdminOrderManageDetail.vue?vue&type=template&id=3fd60fb2&"
import script from "./AdminOrderManageDetail.vue?vue&type=script&lang=js&"
export * from "./AdminOrderManageDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports